import { Box, Flex, Image } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import logo from '../../global/styles/images/launchdeck_logo.svg';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';


function DsrPreviewPageActionModal({ handleCloseModal }) {

  const displayContent = () => {
    return (
      <Box w='100%' py='1.25em'>
        <Flex direction='column' justify='center' alignItems='center' w='100%'>
          <Flex w='100%' justify='center'>
            <Image src={logo} alt="Launchdeck Logo" width='50%' minWidth='1em' maxWidth='10em' mb='2em' />
          </Flex>
          <Flex mb='2em' fontSize='0.875em'>
            You're currently in Preview mode
          </Flex>

          <Flex w='100%' justify={['center']}>
            <LaunchdeckButton bg='brandDark.500' w={['100%', 'auto']} color='gray.50' fontSize='0.8em' py='0.4em' onClick={() => handleCloseModal()} label='OK' />
          </Flex>
        </Flex>
      </Box>
    )
  }



  return (
    <LaunchdeckModal
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

export default DsrPreviewPageActionModal
